import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import ReportFilterList from './ReportFilterList.js';

const ReportFilter = ({
    children,
    filterOptions,
    setFilters
}) => {
    const [filterListOptions, setFilterListOptions] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState(null);


    useEffect(() => {
        if (filterListOptions) {
            setFilters(filterListOptions);
        }
    }, [filterListOptions]);

    useEffect(() => {
        const filterListOptions = [];
        children.map(column => {
            if (column.props.filter) {
                filterListOptions.push({
                    translateId: column.props.id,
                    name: column.props.title,
                    property: column.props.property,
                    type: column.props.filter,
                    value: column.props.initialValue || "",
                    initialValue: column.props.initialValue || "",
                    required: column.props.required,
                    filterProps: column.props.filterProps
                });
            }
        });
        setFilterListOptions(filterListOptions);
    }, []);

    return (
        <>
            {
                filterListOptions.length > 0
                && (
                    <div className="filter-row row filter-height">
                        <ReportFilterList
                            filters={filterListOptions}
                            filterValues={filterOptions}
                            setFilterListOptions={setFilterListOptions}
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}
                        />
                    </div>
                )
            }
        </>
    );
};

ReportFilter.propTypes = {
    children: PropTypes.node.isRequired,
    filterOptions: PropTypes.array,
    columnHeaderFilter: PropTypes.object,
};

ReportFilter.defaultProps = {
    filterOptions: [],
};

export default ReportFilter;
